import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Upload, Trash2, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/creatives`;

export const LogoSetting = () => {
  const [url, setUrl] = useState(null);
  const [busy, setBusy] = useState(false);
  const ref = useRef(null);
  const load = () => axios.get(`${API}/logo`).then((r) => setUrl(r.data.url)).catch(() => {});
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    const fd = new FormData(); fd.append("file", f);
    try { await axios.post(`${API}/logo`, fd); toast.success("Logo salvat — folosit pentru Google Ads (PMax)"); load(); }
    catch (err) { toast.error(err.response?.data?.detail || err.message); }
    setBusy(false); e.target.value = "";
  };
  const remove = async () => { await axios.delete(`${API}/logo`); setUrl(null); };

  return (
    <div className="flex items-center gap-3 rounded-xl border border-zinc-800 bg-zinc-900/50 px-4 py-2.5" data-testid="logo-setting">
      <div className="flex h-10 w-16 items-center justify-center rounded bg-[repeating-conic-gradient(#3f3f46_0%_25%,#27272a_0%_50%)] bg-[length:12px_12px]">
        {url ? <img src={url} alt="logo" className="max-h-9 max-w-14 object-contain" data-testid="logo-preview" /> : <span className="text-[10px] text-zinc-500">fără logo</span>}
      </div>
      <div className="text-xs">
        <p className="font-medium text-zinc-200">Logo brand</p>
        <p className="text-zinc-500">pentru Google Ads (PMax) — nu se mai pune pe poze</p>
      </div>
      <button data-testid="logo-upload-btn" onClick={() => ref.current?.click()} disabled={busy} className="flex items-center gap-1.5 rounded-full border border-zinc-700 px-3 py-1 text-xs text-zinc-200 hover:border-amber-400">
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Upload className="h-3.5 w-3.5" />} {url ? "Schimbă" : "Încarcă PNG"}
      </button>
      {url && <button data-testid="logo-remove-btn" onClick={remove} title="Scoate logo-ul" className="rounded p-1 text-zinc-500 hover:text-rose-400"><Trash2 className="h-4 w-4" /></button>}
      <input ref={ref} type="file" accept="image/png,image/*" hidden onChange={upload} data-testid="logo-upload-input" />
    </div>
  );
};
